export class HelPage {
    constructor(hintsSelector = 'ul.hp-items') {
        this.hintsSelector = hintsSelector
        this.initHints()
        this.createPanel()
        this.markers = []
        this.currentHint = -1
        this.active = false
    }

    createPanel() {
        this.panel = document.createElement('div')
        this.panel.classList.add('hp-panel', 'is-hidden')
        this.panelContent = document.createElement('div')
        this.panelContent.classList.add('hp-panel-content')
        this.panelHeader = document.createElement('div')
        this.panelHeader.classList.add('hp-panel-header')
        let leftBlock = document.createElement('div')
        leftBlock.classList.add('hp-panel-header-left-block')
        this.panelTitle = document.createElement('h5')
        this.panelTitle.classList.add('hp-panel-title', 'title', 'is-5')
        this.btnClose = document.createElement('button')
        this.btnClose.classList.add('button', 'has-no-border', 'hp-panel-close')
        this.btnClose.type = 'button'
        this.btnClose.innerHTML = "<span class='icon'><i class='fa fa-fw fa-times'></i></span>"
        this.btnPrev = document.createElement('button')
        this.btnPrev.classList.add('button', 'has-no-border')
        this.btnPrev.type = 'button'
        this.btnPrev.innerHTML = "<span class='icon'><i class='fa fa-fw fa-angle-left'></i></span>"
        this.btnNext = document.createElement('button')
        this.btnNext.classList.add('button', 'has-no-border')
        this.btnNext.type = 'button'
        this.btnNext.innerHTML = "<span class='icon'><i class='fa fa-fw fa-angle-right'></i></span>"
        this.hintNumLabel = document.createElement('span')
        this.hintNumLabel.classList.add('hp-panel-header-hint-label')
        let closeWrapper = document.createElement('div')
        closeWrapper.appendChild(this.btnClose)
        leftBlock.appendChild(this.btnPrev)
        leftBlock.appendChild(this.hintNumLabel)
        leftBlock.appendChild(this.btnNext)
        leftBlock.appendChild(this.panelTitle)
        this.panelHeader.appendChild(leftBlock)
        this.panelHeader.appendChild(closeWrapper)
        this.panel.appendChild(this.panelHeader)
        this.panel.appendChild(this.panelContent)
        document.body.appendChild(this.panel)
        this.btnClose.addEventListener('click', () => { this.hidePanel() })
        this.btnPrev.addEventListener('click', () => { this.previousHint() })
        this.btnNext.addEventListener('click', () => { this.nextHint() })
    }

    initHints() {
        this.hints = Array.from(document.querySelectorAll(`${this.hintsSelector} > li`))
        if (this.hints.length === 0) {
            document.querySelectorAll('.hlp-toggler').forEach(el => el.classList.add('is-hidden'))
        } else {
            document.querySelectorAll('.hlp-toggler').forEach(el => el.classList.remove('is-hidden'))
        }
    }

    activate() {
        this.createMarkers()
        this.active = true
        document.querySelectorAll('.hlp-toggler').forEach(el => el.classList.add('is-active'))
        /*this.panel.classList.remove('is-hidden')
        this.showHint(0)*/
    }

    deactivate() {
        this.panel.classList.add('is-hidden')
        this.clearMarkers()
        this.panelContent.innerHTML = ''
        this.active = false
        document.querySelectorAll('.hlp-toggler').forEach(el => el.classList.remove('is-active'))
    }

    toggle() {
        if (this.active) {
            this.deactivate()
        } else {
            this.activate()
        }
    }

    createMarkers() {
        this.clearMarkers()

        this.hints.forEach((hint, index) => {
            const target = document.querySelector(hint.dataset.target)
            if (!target) return

            const rect = target.getBoundingClientRect()

            const marker = document.createElement('div')
            marker.className = 'hp-marker'
            marker.dataset.index = index
            marker.textContent = index + 1

            let positioning = hint.dataset.position || 'absolute'

            if (target.closest('.modal')) {
                marker.style.zIndex = 100
                positioning = 'fixed'
            }

            // Pozice markeru (můžeš později vylepšit o positions)
            marker.style.position = positioning
            // default: left
            marker.style.top = window.scrollY + rect.top - 20 + 'px'
            marker.style.left = window.scrollX + rect.left - 35 + 'px'
            if (hint.dataset.positionDir === 'left-in') {
                marker.style.top = window.scrollY + rect.top - 12 + 'px'
                marker.style.left = window.scrollX + rect.left + 5 + 'px'
            }
            if (hint.dataset.positionDir === 'right-in') {
                marker.style.top = window.scrollY + rect.top - 12 + 'px'
                marker.style.left = window.scrollX + rect.right - 35 + 'px'
            }
            if (hint.dataset.positionDir === 'right') {
                marker.style.left = window.scrollX + rect.right + 5 + 'px'
            }
            if (positioning !== 'absolute') {
                marker.style.top = rect.top + 5 + 'px'
                marker.style.left = rect.left - 15 + 'px'
            }

            marker.addEventListener('click', () => {
                if (this.currentHint === index) {
                    this.hidePanel()
                } else {
                    this.showHint(index)
                }
            })

            document.body.appendChild(marker)
            this.markers.push(marker)
        })
    }

    clearMarkers() {
        this.markers.forEach(m => m.remove())
        this.markers = []
    }

    showHint(i) {
        this.currentHint = i
        this.hintNumLabel.textContent = (i + 1)
        this.markers.forEach(m => { m.classList.remove('is-active') })
        this.markers[i].classList.add('is-active')
        this.panelContent.innerHTML = this.hints[i].innerHTML
        this.panelTitle.textContent = this.hints[i].dataset.title || 'Hint #' + (i + 1)
        this.panel.classList.remove('is-hidden')

        // Scroll na marker
        this.markers[i].scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }

    nextHint() {
        this.currentHint = (this.currentHint + 1) % this.hints.length
        this.showHint(this.currentHint)
    }

    previousHint() {
        this.currentHint = (this.currentHint - 1 + this.hints.length) % this.hints.length
        this.showHint(this.currentHint)
    }

    hidePanel() {
        this.panel.classList.add('is-hidden')
        this.currentHint = -1
        this.markers.forEach(m => { m.classList.remove('is-active') })
    }
}

/*
// Použití
const pg = new HelPage()

document.getElementById('help-btn').addEventListener('click', () => {
  pg.activate()
})
*/
